import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import {  Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { connect } from "react-redux";
import MortgageForm from "./MorgageForm";
import { HideAddMrtg } from "../../actions/loading";


class PropertyReportMrtg extends Component {
    constructor(...args) {
        super(...args);
        
    }
    submit = (values) => {

    }
    render() {
        return (
          <>
            <Modal
              isOpen={this.props.display}
              contentClassName="custom-large-modal-style"
            >
              <form
                onSubmit={this.props.handleSubmit(this.submit)}
                style={{ marginLeft: "0%", marginRight: "0%" }}
              >
                <ModalHeader>Add Mortgage</ModalHeader>
                <ModalBody>
                  <MortgageForm />
                </ModalBody>
                <ModalFooter>
                  <div className="col-12 pb-2 text-right">
                    <Button color="primary" type="submit" className="mr-3">
                      Save
                    </Button>
                    <Button
                      type="button"
                      onClick={() => this.props.HideAddMrtg()}
                    >
                      Cancel
                    </Button>
                  </div>
                </ModalFooter>
              </form>
            </Modal>
          </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};
    return errors;
}
var propertyReportMrtgForm = reduxForm({
    form: 'propertyReportMrtgForm',
    validate
})(PropertyReportMrtg);

propertyReportMrtgForm = connect(
    state => ({
        session: state.session,
        display: state.loadDeed.displayaddmrtg
    }),
    {HideAddMrtg}
)(propertyReportMrtgForm);

export default propertyReportMrtgForm;